export const PRODUCT_VIEW_IMAGE_SIZES = [
  "(min-width: 1240px) 948px",
  "(min-width: 896px) 474px",
  "(min-width: 474px) 948px",
  "(min-width: 237px) 474px",
  "237px",
].join();

export const PRODUCT_VIEW_THUMB_SIZES = "100px";

export const RELATED_PRODUCTS_IMAGE_SIZES = [
  "(min-width: 1281px) 544px",
  "(min-width: 385px) 272px",
  "136px",
].join();
